"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseTypeEnum = void 0;
var LicenseTypeEnum;
(function (LicenseTypeEnum) {
    LicenseTypeEnum["Admin"] = "Admin";
    LicenseTypeEnum["All"] = "All";
    LicenseTypeEnum["Voice"] = "Voice";
    LicenseTypeEnum["Email"] = "Email";
    LicenseTypeEnum["Dashboard"] = "Dashboard";
    LicenseTypeEnum["Reporting"] = "Reporting";
})(LicenseTypeEnum = exports.LicenseTypeEnum || (exports.LicenseTypeEnum = {}));
